<template>
  <div class="container-fluid">
    <div class="card shadow-lg mt-3">
      <div class="card-body p-3">
        <div class="d-flex justify-content-between align-items-center">
          <!-- Titolo a sinistra -->
          <div>
            <header-title
              :id="this.idCustomer"
              :title="'Nuovo cliente'"
              :edit-title="'Modifica cliente'"
            ></header-title>
          </div>
          
          <!-- Bottone back a destra -->
          <div>
            <back-to-list :url="'/clienti'"></back-to-list>
          </div>
        </div>
      </div>
    </div>
</div>
  <vee-form :validation-schema="customerSchema" @submit="saveCustomer">
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <argon-alert color="danger" v-if="show_alert"
                >{{ alert_msg }}
              </argon-alert>
              <argon-alert color="success" v-if="show_success"
                >{{ alert_msg }}
              </argon-alert>
              <div class="row">
                <div class="col-md-6">
                  <label for="code" class="form-control-label">Codice cliente</label>

                  <vee-field
                    type="text"
                    class="form-control"
                    name="code"
                    id="code"
                    v-model="this.customer.code"
                  />
                </div>
                <div class="col-md-6">
                  <label for="name" class="form-control-label">Ragione sociale</label>

                  <vee-field
                    type="text"
                    class="form-control"
                    name="name"
                    id="name"
                    v-model="this.customer.name"
                  />
                </div>
                <div class="col-md-12">
                  <label for="address" class="form-control-label">Indirizzo</label>

                  <vee-field
                    type="text"
                    class="form-control"
                    name="address"
                    id="address"
                    v-model="this.customer.address"
                  />
                </div>
                <div class="col-md-12">
                  <div class="form-check form-switch mt-2">
                    <vee-field
                      class="form-check-input"
                      type="checkbox"
                      id="enabled"
                      name="enabled"
                      :checked="this.customer.enabled"
                      v-model="this.customer.enabled"
                      :value="true"
                      :unchecked-value="false"
                    />
                    <label
                      class="form-check-label"
                      :for="this.customer.enabled"
                    >
                      Abilita
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <argon-button
                  size="sm"
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  >Salva
                </argon-button>
                <router-link
                  to="/clienti"
                  class="btn btn-sm btn-dark float-right mt-4 mb-0 d-none d-lg-block"
                >
                  Annulla
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vee-form>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";
import ArgonAlert from "@/components/ArgonAlert.vue";
import router from "@/router";
import BackToList from "@/components/Header/BackToList.vue";
import HeaderTitle from "@/components/Header/HeaderTitle.vue";

export default {
  name: "customer-edit",
  data() {
    return {
      customerSchema: {
        code: "required"
      },
      show_alert: false,
      show_success: false,
      alert_msg: "",
      customer: {
        code: "",
        name: "",
        address: "",
        enabled: false,
      },
      idCustomer: "",
    };
  },
  beforeMount() {
    this.idCustomer = this.$route.params.id;
  },
  async mounted() {
    await this.getCustomer();
  },
  components: { HeaderTitle, BackToList, ArgonAlert, ArgonButton },
  methods: {
    router() {
      return router;
    },
    async getCustomer() {
      try {
        if (this.idCustomer) {
          const response = await axios.get(
            this.$endpoint + "/customer/show/" + this.idCustomer,
            {
              headers: {
                authorization: process.env.VUE_APP_APY_KEY,
              },
            }
          );

          if (response.data.status === "OK") {
            this.customer = response.data.data;
          }
        }
      } catch (e) {
        console.log(e.toString());
      }
    },
    async saveCustomer() {
      try {
        // Validazione base
        if (!this.customer.code?.trim()) {
          this.show_alert = true;
          this.alert_msg = "Codice e nome sono obbligatori";
          return;
        }

        const response = await axios.post(
          `${this.$endpoint}/customer/add`,
          {
            code: this.customer.code.trim(),
            name: this.customer.name.trim(),
            address: this.customer.address.trim(),
            enabled: this.customer.enabled,
          },
          {
            params: { id: this.idCustomer },
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        if (response.data.status === "OK") {
          this.show_success = true;
          this.alert_msg = this.idCustomer 
            ? "Cliente aggiornato con successo" 
            : "Cliente creato con successo";
          
          // Redirect alla lista dopo 1.5 secondi
          setTimeout(() => {
            this.$router.push('/clienti');
          }, 1500);
          
        } else {
          this.show_alert = true;
          this.alert_msg = response.data.message;
        }
        
      } catch (error) {
        this.show_alert = true;
        
        // Gestione errori più specifica
        if (error.response) {
          // Errore dalla risposta del server
          this.alert_msg = error.response.data?.message || "Errore nel salvataggio del cliente";
        } else if (error.request) {
          // Richiesta effettuata ma nessuna risposta
          this.alert_msg = "Errore di connessione al server";
        } else {
          // Altro tipo di errore
          this.alert_msg = "Errore imprevisto nel salvataggio";
        }
        
        console.error("Errore salvataggio cliente:", error);
      }
    }
  },
};
</script>
